<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      max-width="760"
      scrollable
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          color="primary"
          icon
          v-on="on"
        >
          <v-icon :title="'Cálculo Repasse'">
            calculate
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-h6 primary white--text py-3 px-4 d-flex align-center">
          <v-icon
            left
            dark
          >
            calculate
          </v-icon>
          Cálculo Repasse
        </v-card-title>

        <v-card-text class="pa-4">
          <template v-if="parsed">
            <v-row dense>
              <v-col
                v-for="cat in parsed.categorias"
                :key="cat.nome"
                cols="12"
                sm="6"
              >
                <div class="cat-card">
                  <div class="cat-card__title">
                    <v-icon
                      small
                      color="primary"
                      class="mr-1"
                    >
                      {{ catIcon(cat.nome) }}
                    </v-icon>
                    {{ cat.nome }}
                  </div>
                  <div
                    v-for="(item, i) in cat.itens"
                    :key="i"
                    class="calc-row"
                    :class="{ 'calc-row--destaque': item.destaque }"
                  >
                    <div class="calc-row__label">
                      <span>{{ item.nome }}</span>
                      <span
                        v-if="item.formula"
                        class="calc-row__formula"
                      >{{ item.formula }}</span>
                    </div>
                    <div
                      class="calc-row__valor"
                      :class="{ 'primary--text': item.destaque }"
                    >
                      {{ item.valor }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div class="totais mt-4">
              <div
                v-for="(t, i) in parsed.totais"
                :key="i"
                class="total-row"
                :class="isTaxa(t.nome) ? 'total-row--hero primary white--text' : ''"
              >
                <div class="total-row__label">
                  <span>{{ t.nome }}</span>
                  <span
                    v-if="t.formula"
                    class="total-row__formula"
                  >{{ t.formula }}</span>
                </div>
                <div class="total-row__valor">
                  {{ t.valor }}
                </div>
              </div>
            </div>

            <div
              v-if="parsed.responsavel"
              class="responsavel mt-4"
            >
              <v-icon
                small
                class="mr-1"
              >
                person
              </v-icon>
              <span><strong>Responsável:</strong> {{ parsed.responsavel }}</span>
              <span
                v-if="parsed.cpf"
                class="ml-3"
              ><strong>CPF:</strong> {{ parsed.cpf }}</span>
            </div>
            <v-expand-transition>
              <div
                v-if="showTexto"
                class="texto-completo mt-4"
              >
                <div class="texto-completo__label">
                  Texto completo
                </div>
                <p class="memoria-calculo-texto mb-0">
                  {{ memoriaCalculo }}
                </p>
              </div>
            </v-expand-transition>
          </template>

          <p
            v-else
            class="memoria-calculo-texto"
          >
            {{ memoriaCalculo }}
          </p>
        </v-card-text>
        <v-divider />

        <v-card-actions class="px-4 py-3">
          <v-btn
            color="primary"
            text
            @click="copiarCalculo"
          >
            <v-icon
              left
              small
            >
              content_copy
            </v-icon>
            copiar texto
          </v-btn>
          <v-btn
            v-if="parsed"
            color="primary"
            text
            @click="showTexto = !showTexto"
          >
            {{ showTexto ? 'ocultar texto' : 'ver texto completo' }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AuthService from "@/services/gessan/auth.service";

export default {
  name: "DialogMemoriaCalculo",
  props: {
    memoriaCalculo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      showTexto: false,
    };
  },
  computed: {
    parsed() {
      try {
        const raw = (this.memoriaCalculo || "").trim();
        if (!raw) return null;

        const sentences = raw
          .split(/\.\s+/)
          .map(s => s.replace(/\.$/, "").trim())
          .filter(Boolean);

        const categorias = [];
        const totais = [];
        let responsavel = null;
        let cpf = null;

        sentences.forEach(sentence => {
          if (/Repasse/i.test(sentence) && sentence.includes(":")) {
            const idx = sentence.indexOf(":");
            const nome = sentence.slice(0, idx).trim();
            const itens = sentence
              .slice(idx + 1)
              .split(";")
              .map(s => s.trim())
              .filter(Boolean)
              .map(p => this.parseParte(p));
            categorias.push({ nome, itens });
          } else if (/^Respons[aá]vel/i.test(sentence)) {
            const rm = sentence.match(
              /Respons[aá]vel:\s*(.*?),\s*CPF do Respons[aá]vel:\s*(.+)/i
            );
            if (rm) {
              responsavel = rm[1].trim();
              cpf = rm[2].trim();
            }
          } else if (sentence.includes("=")) {
            totais.push(this.parseParte(sentence));
          }
        });

        if (!categorias.length && !totais.length && !responsavel) return null;
        return { categorias, totais, responsavel, cpf };
      } catch (e) {
        return null;
      }
    },
  },
  methods: {
    parseParte(part) {
      const bits = part.split("=");
      const nome = bits[0].trim();
      if (bits.length === 1) {
        return { nome, formula: "", valor: "", destaque: false };
      }
      const valor = bits[bits.length - 1].trim();
      const formula = bits.slice(1, -1).join("=").trim();
      return { nome, formula, valor, destaque: /repasse/i.test(nome) };
    },
    catIcon(nome) {
      return /[aá]gua/i.test(nome) ? "opacity" : "waves";
    },
    isTaxa(nome) {
      return /taxa/i.test(nome);
    },
    async copiarCalculo() {
      try {
        await navigator.clipboard.writeText(this.memoriaCalculo);
      } catch (err) {
        this.copiarComFallback();
      }
      AuthService.globalStore("success", "Cálculo copiado para a área de transferência");
    },
    copiarComFallback() {
      const textarea = document.createElement("textarea");
      textarea.value = this.memoriaCalculo;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
  },
};
</script>
<style scoped>
.memoria-calculo-texto {
  white-space: pre-wrap;
  text-align: left;
  word-break: break-word;
}

.cat-card {
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fafafa;
}

.cat-card__title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 0.92rem;
  color: rgba(0, 0, 0, 0.75);
  padding-bottom: 6px;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
}

.calc-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 6px 0;
  text-align: left;
}

.calc-row + .calc-row {
  border-top: 1px dashed #ececec;
}

.calc-row--destaque {
  background: rgba(25, 118, 210, 0.08);
  border-radius: 6px;
  border-top: none !important;
  margin: 2px -6px;
  padding: 6px;
}

.calc-row__label {
  display: flex;
  flex-direction: column;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
}

.calc-row__formula {
  font-size: 0.72rem;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 2px;
}

.calc-row__valor {
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.85);
}

.totais {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f2f4f7;
  text-align: left;
}

.total-row__label {
  display: flex;
  flex-direction: column;
  font-size: 0.85rem;
  font-weight: 600;
}

.total-row__formula {
  font-size: 0.72rem;
  font-weight: 400;
  opacity: 0.7;
  margin-top: 2px;
}

.total-row__valor {
  font-weight: 700;
  font-size: 0.95rem;
  white-space: nowrap;
}

.total-row--hero {
  padding: 14px;
}

.total-row--hero .total-row__label {
  font-size: 0.95rem;
}

.total-row--hero .total-row__valor {
  font-size: 1.35rem;
}

.responsavel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  text-align: left;
}

.texto-completo {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fafafa;
}

.texto-completo__label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 6px;
}

.texto-completo .memoria-calculo-texto {
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.7);
  user-select: all;
}
</style>
